import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';
import { getStopRoutingCoordinates } from '@/components/shipment/form/utils/shipment-form-stop-coords';

/**
 * Fingerprint of stop keys + routing coordinates (same semantics as the composer auto-route watcher).
 * Returns `null` when fewer than two stops or any stop lacks routable coordinates.
 */
export function computeStopsRouteFingerprint(
  stops: ShipmentFormStopRow[],
): string | null {
  if (stops.length < 2) return null;
  for (const s of stops) {
    if (getStopRoutingCoordinates(s) == null) return null;
  }
  return stops
    .map((s) => {
      const c = getStopRoutingCoordinates(s)!;
      return `${s.key}:${c.lat.toFixed(5)},${c.lng.toFixed(5)}`;
    })
    .join('|');
}
